import React from 'react';

import {invariant} from 'src/utils';

const ChatCenterWidgetContext = React.createContext<{unreadCount: number; isOpen: boolean}>({
  unreadCount: 0,
  isOpen: false,
});

const ChatCenterWidgetContextProvider = React.memo<{children: React.ReactNode}>(({children}) => {
  const [unreadCount, setUnreadCount] = React.useState(0);
  const [isOpen, setIsOpen] = React.useState(false);

  const initialize = React.useCallback(() => {
    invariant('window.ThreadsWidget is missing while init', window.ThreadsWidget);
    window.ThreadsWidget.onLoad(() => {
      window.ThreadsWidget!.on('changeUnreadCounter', (counter) => {
        setUnreadCount(counter);
      });

      window.ThreadsWidget!.on('hideChat', () => {
        setIsOpen(false);
      });

      window.ThreadsWidget!.on('showChat', () => {
        setIsOpen(true);
      });
    });
  }, []);

  React.useEffect(() => {
    const intervalId = setInterval(() => {
      if (window.ThreadsWidget) {
        initialize();
        clearInterval(intervalId);
      }
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  const state = React.useMemo(() => ({unreadCount, isOpen}), [unreadCount, isOpen]);

  return (
    <ChatCenterWidgetContext.Provider value={state}>{children}</ChatCenterWidgetContext.Provider>
  );
});

const useChatCenterWidgetState = () => {
  const state = React.useContext(ChatCenterWidgetContext);

  invariant('useChatCenterWidgetState used outside context', state);

  return state;
};

export {ChatCenterWidgetContextProvider, useChatCenterWidgetState};
